import { render } from "./HeroSection.vue?vue&type=template&id=343f8058&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=343f8058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343f8058"]])

export default __exports__